import Colors from '@dynatrace/strato-design-tokens/colors';
import Typography from '@dynatrace/strato-design-tokens/typography';

import { TextPropsRequired } from './types.js';
import type { MappedObject } from '../../types/helpers/mapped-object.js';

/* Offset between the x axis ticks and x axis line */
export const X_AXES_TICK_LINE_OFFSET = 4;

/* Offset between the y axis ticks and y axis line */
export const Y_AXES_TICK_LINE_OFFSET = 6;

/* Fixed label's height to be used. Remember: axis label means the title of the axis */
export const AXIS_LABEL_HEIGHT = 12;

/* The minimum number of scale steps needed to show tick labels when located on the left */
export const MIN_SCALE_STEPS = AXIS_LABEL_HEIGHT;

/* Offset to substract due to Flex adding additional spacing */
const FLEX_OFFSET = 4;

/* Offset between tick label and label for x axes*/
export const X_AXES_LABEL_OFFSET = X_AXES_TICK_LINE_OFFSET + 6 - FLEX_OFFSET;

/* Offset between tick label and label for y axis */
export const Y_AXIS_LABEL_OFFSET = 6;

/* Offset between the top x axis ticks and top axis line */
export const TOP_AXIS_LINE_OFFSET = 18;

/* Offset for the top axis */
export const TOP_AXIS_LABEL_OFFSET = 8;

/* Offset for the bottom axis */
export const BOTTOM_AXIS_LINE_OFFSET = 8;

/* The minimum size the axis could truncate for both vertical and horizontal */
export const MIN_AXIS_TRUNCATION_SIZE = 33;

export const MAX_ANNOTATIONS_AREA_HEIGHT = 46;

/* A value representation for the line-height text rendered */
export const TICK_LINE_HEIGHT = 14;
export const TICK_LINE_ICON_OFFSET = 4;

export const Y_LABEL_AREA = AXIS_LABEL_HEIGHT + Y_AXIS_LABEL_OFFSET;

export const X_LABEL_AREA = AXIS_LABEL_HEIGHT + X_AXES_LABEL_OFFSET;

export type TickAligmentMode = 'start' | 'middle' | 'end';

export const TICK_ALIGMENT: MappedObject<TickAligmentMode> = {
  Start: 'start',
  Middle: 'middle',
  End: 'end',
};

export const DEFAULT_AXIS_FONT_COLOR = Colors.Text.Neutral.Subdued;

/*
 * These styles are meant to be applied for the axis
 */
export const axisFontProps: TextPropsRequired = {
  fill: DEFAULT_AXIS_FONT_COLOR,
  color: DEFAULT_AXIS_FONT_COLOR,
  fontSize: Typography.Text.Small.Emphasized.Size,
  fontFamily: Typography.Text.Small.Emphasized.Family,
};

export const axisFontBaseProps: TextPropsRequired = {
  fill: DEFAULT_AXIS_FONT_COLOR,
  color: DEFAULT_AXIS_FONT_COLOR,
  fontSize: Typography.Text.Base.Emphasized.Size,
  fontFamily: Typography.Text.Base.Emphasized.Family,
};

/**
 * Regular expression that matches any emoji character.
 *
 * This regex uses Unicode property escapes to match characters with either
 * the `Emoji_Presentation` or `Extended_Pictographic` properties, which
 * together cover most emoji symbols and pictographs.
 *
 * https://www.unicode.org/Public/UCD/latest/ucd/emoji/emoji-data.txt
 */
export const EMOJI_REGEX =
  /(\p{Emoji_Presentation}|\p{Extended_Pictographic})/u;
